WiseMetering.Views.DestroyTenant = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.tenants.destroy')
});
